var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
      _vm.classes, {
      'fadeInUp': _vm.value > 0,
      'fadeOutDown': _vm.value <= 0,
    }]},[(_vm.label)?_c('span',{staticClass:"mb-0 tool__badge-label",domProps:{"innerHTML":_vm._s(_vm.label)}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text-truncate tool__badge d-block",class:_vm.inputClasses,domProps:{"innerHTML":_vm._s(_vm.valueReadable)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }